































































































import { AvaliacaoNpsConfigLoja } from '@/models'
import { AvaliacaoNps, AvaliacaoNpsResposta, TipoAvaliacaoNps } from '@/models/venda'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindVendaUseCase } from '@/usecases'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class DialogoDeAvaliacaoNpsDoCliente extends Vue {
	mostra = false
	salvando = false
	vendaIdentificador = ''
	avaliacao: AvaliacaoNps | null = null
	respostasLocal: AvaliacaoNpsResposta[] = []
	escalaNps = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
	avaliacaoNpsConfigLoja: AvaliacaoNpsConfigLoja[] = []
	vendedorId = ''

	findVendaUseCase = new FindVendaUseCase()

	mostrar(identificador: string, avaliacao: AvaliacaoNps, avaliacaoNpsConfigLoja: AvaliacaoNpsConfigLoja[], vendedorId: string) {
		this.vendaIdentificador = identificador
		this.avaliacao = avaliacao
		this.avaliacaoNpsConfigLoja = avaliacaoNpsConfigLoja
		this.vendedorId = vendedorId
		this.mostra = true
		this.syncFromProp()
	}

	get configsAtivasOrdenadas(): AvaliacaoNpsConfigLoja[] {
		return (this.avaliacaoNpsConfigLoja || [])
			.filter(cfg => cfg.ativo)
			.sort((a, b) => (a.ordem || 0) - (b.ordem || 0))
	}

	get respostasOrdenadas(): AvaliacaoNpsResposta[] {
		const mapaRespostas = new Map<TipoAvaliacaoNps, AvaliacaoNpsResposta>()

		this.respostasLocal.forEach(r => {
			mapaRespostas.set(r.tipo, r)
		})

		return this.configsAtivasOrdenadas
			.map(cfg => mapaRespostas.get(cfg.tipo))
			.filter((r): r is AvaliacaoNpsResposta => !!r)
	}

	@Watch('avaliacao', { immediate: true, deep: true })
	onAvaliacaoChanged() {
		this.syncFromProp()
	}

	@Watch('avaliacaoNpsConfigLoja', { immediate: true, deep: true })
	onConfigsChanged() {
		this.syncFromProp()
	}

	syncFromProp() {
		if (!this.avaliacao) {
			this.respostasLocal = []
			return
		}

		const configs = this.configsAtivasOrdenadas

		if (!configs.length) {
			this.respostasLocal = []
			return
		}

		this.respostasLocal = configs.map(cfg => ({
			avaliacaoNpsId: this.avaliacao!.id,                
			tipo: cfg.tipo,                                     
			nota: null,                                         
			resposta: '',                                      
			pergunta: cfg.pergunta || this.getPergunta(cfg.tipo), 
		} as AvaliacaoNpsResposta))
	}

	fechar() {
		this.mostra = false
	}

	async salvar() {
		if (!this.avaliacao) {
			return AlertModule.setError('Erro ao salvar avaliação.')
		}

		const obrigatorias = this.configsAtivasOrdenadas.filter(c => c.obrigatoria)
		const respostasPorTipo = new Map(
			this.respostasLocal.map(r => [r.tipo, r] as [TipoAvaliacaoNps, AvaliacaoNpsResposta]),
		)

		const faltando = obrigatorias.find(cfg => {
			const r = respostasPorTipo.get(cfg.tipo)
			if (!r) return true

			if (this.isPerguntaDeTexto(cfg.tipo)) {
				return !r.resposta || !r.resposta.trim()
			}

			return r.nota === null || r.nota === undefined
		})

		if (faltando) {
			AlertModule.setError('Responda todas as perguntas obrigatórias antes de enviar.')
			return
		}

		this.salvando = true
		try {
			const respostasParaEnvio: AvaliacaoNpsResposta[] = this.respostasLocal.map(r => {
				const ehNota =
					this.isPerguntaDeNota(r.tipo) || this.isPerguntaDeNotaArea(r.tipo)

				return {
					id: '',
					avaliacaoNpsId: r.avaliacaoNpsId,
					tipo: r.tipo,
					resposta: r.resposta,
					pergunta: r.pergunta,
					nota: ehNota ? (r.nota ?? 0) : r.nota,
				}
			})

			await this.findVendaUseCase.criaAvaliacaoNpsRespostaDoCliente(this.avaliacao.id, respostasParaEnvio, this.vendedorId)

			const payload: AvaliacaoNps = {
				...this.avaliacao,
				respostas: respostasParaEnvio,
			}

			this.$emit('salvar', payload)
			this.mostra = false
		} finally {
			this.salvando = false
		}
	}


	isPerguntaDeNota(tipo: TipoAvaliacaoNps): boolean {
		return tipo === 'Geral'
	}

	isPerguntaDeNotaArea(tipo: TipoAvaliacaoNps): boolean { 
		return ['Atendimento', 'Produtos', 'Preços e condições', 'Entrega e retirada'].includes(
			tipo,
		)
	}

	isPerguntaDeTexto(tipo: TipoAvaliacaoNps): boolean {
		return ['Motivo', 'Sugestão de melhoria'].includes(tipo)
	}

	getLabel(tipo: TipoAvaliacaoNps): string {
		return tipo
	}

	getPergunta(tipo: TipoAvaliacaoNps): string {
		const cfg = this.avaliacaoNpsConfigLoja.find(c => c.tipo === tipo)

		if (cfg && cfg.pergunta) {
			return cfg.pergunta
		}

		switch (tipo) {
			case 'Geral':
				return 'Quão provável é que você recomende nossa loja a um amigo ou familiar?'
			case 'Atendimento':
				return 'Como você avalia o atendimento recebido?'
			case 'Produtos':
				return 'Como você avalia os produtos adquiridos?'
			case 'Preços e condições':
				return 'Como você avalia os preços e condições de pagamento?'
			case 'Entrega e retirada':
				return 'Como você avalia o processo de entrega ou retirada?'
			case 'Motivo':
				return 'Conte-nos o motivo da sua nota (opcional)'
			case 'Sugestão de melhoria':
				return 'Deixe aqui suas sugestões de melhoria (opcional)'
			default:
				return 'Como você avalia esta área?'
		}
	}

	getPlaceholderTexto(tipo: TipoAvaliacaoNps): string {
		switch (tipo) {
			case 'Motivo':
				return 'Conte-nos o motivo da sua nota (opcional)'
			case 'Sugestão de melhoria':
				return 'Deixe aqui suas sugestões de melhoria (opcional)'
			default:
				return 'Comentário'
		}
	}
}
